import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15df0f63"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "item" }
const _hoisted_3 = { class: "item" }
const _hoisted_4 = { class: "item" }
const _hoisted_5 = { class: "item" }
const _hoisted_6 = { class: "item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "l1" }, "是否恶意投诉或低质量服务", -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode("是")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("否")
const _hoisted_10 = { class: "item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "l1" }, "责任划分", -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode("双方无责")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("司机责任")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("用户责任")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("双方都有责任")
const _hoisted_16 = { class: "item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "l1" }, "赔偿金额", -1))
const _hoisted_18 = { class: "item" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "l1" }, "备注", -1))
const _hoisted_20 = /*#__PURE__*/_createTextVNode("确定仲裁")
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"30px"} }, null, -1))
const _hoisted_22 = /*#__PURE__*/_createTextVNode("U")
const _hoisted_23 = { class: "con" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("D")
const _hoisted_25 = { class: "con" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding-bottom":"10px","font-weight":"700"} }, "请输入不通过的原因", -1))
const _hoisted_28 = { key: 1 }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding-bottom":"10px","font-weight":"700"} }, "确定审核通过吗？", -1))
const _hoisted_30 = [
  _hoisted_29
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_image_preview_group = _resolveComponent("a-image-preview-group")!
  const _component_a_comment = _resolveComponent("a-comment")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.detail)
      ? (_openBlock(), _createBlock(_component_a_card, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_descriptions, {
              title: "订单信息",
              bordered: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_descriptions_item, { label: "订单编号" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.sn), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "订单状态" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.getLogisticsOrderStatus(_ctx.detail?.status)?.name), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "订单模式" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.getPayMethod(_ctx.detail?.mode)?.name), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "支付状态" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.getPayStatus(_ctx.detail?.pay_status)?.name), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "支付方式" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.getPayMethod(_ctx.detail?.payment_method)?.name), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "寄件方式" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.getShipMethod(_ctx.detail?.ship_type)?.name), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, {
                  label: "金额信息(元)",
                  span: 3
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, "运费：" + _toDisplayString(_ctx.detail?.money), 1),
                    _createElementVNode("div", _hoisted_3, "代收尾款：" + _toDisplayString(_ctx.detail?.charges), 1),
                    _createElementVNode("div", _hoisted_4, "优惠金额：" + _toDisplayString(_ctx.detail?.discount_amount), 1),
                    _createElementVNode("div", _hoisted_5, "付款金额：" + _toDisplayString(_ctx.detail?.pay_amount), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, {
                  label: "仲裁",
                  span: 3
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _hoisted_7,
                      _createVNode(_component_a_radio_group, {
                        value: _ctx.data.malicious,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.data.malicious) = $event)),
                        name: "radioGroup"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_radio, { value: "1" }, {
                            default: _withCtx(() => [
                              _hoisted_8
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_radio, { value: "0" }, {
                            default: _withCtx(() => [
                              _hoisted_9
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _createVNode(_component_a_radio_group, {
                        value: _ctx.data.responsible_party,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.data.responsible_party) = $event)),
                        name: "radioGroup"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_radio, { value: "0" }, {
                            default: _withCtx(() => [
                              _hoisted_12
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_radio, { value: "1" }, {
                            default: _withCtx(() => [
                              _hoisted_13
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_radio, { value: "2" }, {
                            default: _withCtx(() => [
                              _hoisted_14
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_radio, { value: "3" }, {
                            default: _withCtx(() => [
                              _hoisted_15
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["value"])
                    ]),
                    _createElementVNode("div", _hoisted_16, [
                      _hoisted_17,
                      _createVNode(_component_a_input_number, {
                        type: "number",
                        min: 0.00,
                        precision: 2,
                        value: _ctx.data.compensation,
                        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.data.compensation) = $event)),
                        style: {"width":"100%"}
                      }, null, 8, ["min", "value"])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _createVNode(_component_a_textarea, {
                        value: _ctx.data.remark,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.data.remark) = $event))
                      }, null, 8, ["value"])
                    ]),
                    _createVNode(_component_a_button, {
                      type: "primary",
                      onClick: _ctx.onArbitration
                    }, {
                      default: _withCtx(() => [
                        _hoisted_20
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _hoisted_21,
            _createVNode(_component_a_descriptions, { title: "投诉信息" }),
            _createVNode(_component_a_list, {
              class: "comment-list",
              "item-layout": "horizontal",
              "data-source": _ctx.detail?.complaints || []
            }, {
              renderItem: _withCtx(({ item }) => [
                _createVNode(_component_a_list_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_comment, {
                      author: _ctx.detail?.user?.nickname || '用户',
                      datetime: item.create_time
                    }, {
                      avatar: _withCtx(() => [
                        _createVNode(_component_a_avatar, {
                          src: _ctx.detail?.user?.avatar,
                          style: {"background-color":"#f56a00"}
                        }, {
                          default: _withCtx(() => [
                            _hoisted_22
                          ]),
                          _: 1
                        }, 8, ["src"])
                      ]),
                      content: _withCtx(() => [
                        _createElementVNode("div", _hoisted_23, _toDisplayString(item.content), 1),
                        _createVNode(_component_a_image_preview_group, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.images, (img) => {
                              return (_openBlock(), _createBlock(_component_a_image, {
                                width: 130,
                                height: 130,
                                src: img
                              }, null, 8, ["src"]))
                            }), 256))
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.appeals, (appeal) => {
                          return (_openBlock(), _createBlock(_component_a_comment, {
                            author: _ctx.detail?.courier?.name || '司机',
                            datetime: appeal.create_time
                          }, {
                            avatar: _withCtx(() => [
                              _createVNode(_component_a_avatar, {
                                src: _ctx.detail?.courier?.head_img || '',
                                style: {"background-color":"cornflowerblue"}
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_24
                                ]),
                                _: 1
                              }, 8, ["src"])
                            ]),
                            content: _withCtx(() => [
                              _createElementVNode("div", _hoisted_25, _toDisplayString(appeal.content), 1),
                              _createVNode(_component_a_image_preview_group, null, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(appeal.images, (img) => {
                                    return (_openBlock(), _createBlock(_component_a_image, {
                                      width: 130,
                                      height: 130,
                                      src: img
                                    }, null, 8, ["src"]))
                                  }), 256))
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["author", "datetime"]))
                        }), 256)),
                        (item.arbitration)
                          ? (_openBlock(), _createBlock(_component_a_descriptions, {
                              key: 0,
                              bordered: ""
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_descriptions_item, { label: "仲裁结果" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.detail?.sn), 1)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["author", "datetime"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            }, 8, ["data-source"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_a_modal, {
      visible: _ctx.visible,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.visible) = $event)),
      title: _ctx.pass ? '审核通过' : '审核不通过',
      onOk: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onAudit(false))),
      confirmLoading: _ctx.loading
    }, {
      default: _withCtx(() => [
        (!_ctx.pass)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _hoisted_27,
              _createVNode(_component_a_textarea, {
                value: _ctx.reason,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.reason) = $event)),
                placeholder: "请输入不通过的原因",
                rows: 4
              }, null, 8, ["value"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_28, _hoisted_30))
      ]),
      _: 1
    }, 8, ["visible", "title", "confirmLoading"])
  ]))
}